import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'client-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class ClientEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
